<template>
   <div>
    <app-order-form />      
   </div>
</template>

<script>
    import OrderForm from '@/components/Order/OrderForm.vue'
    export default {
        components: {
            AppOrderForm: OrderForm
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue